<script>
import api from '@/helpers/api'
export default {
  name: 'tag-watch-form-dialog',
  props: {
    visible: { type: Boolean, default: false },
    reportId: { type: String },
    copyReportId: { type: String },
    headerTitle: { type: String, default: 'Tag Watch' }
  },
  data: () => ({
    report: {},
    isLoading: false,
    usedTags: []
  }),
  methods: {
    reset () {
      this.report = {}
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      this.usedTags = await api.usedItemTags.fetchAll()

      if (this.isUpdate) {
        let result = await api.itemTagStatWatch.fetch({
          id: this.reportId
        })
        this.report = { ...result }
      } else {
        if (this.copyReportId) {
          let { description, tags, id } = await api.itemTagStatWatch.fetch({
            report_id: this.copyReportId
          })

          this.report = { id, description, tags }
        } else this.report = {}
      }
    },
    onSave () {
      let valid = true
      if (valid) {
        this.$emit('created', this.report)
        this.onCancel()
      }
    }
  },
  watch: {
    reportId: { handler: 'init', immediate: true },
    copyReportId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.reportId
    },
    title () {
      return this.isUpdate
        ? `Edit ${this.headerTitle}`
        : `New ${this.headerTitle}`
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Report'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <b-form-group
      label="Description"
      label-for="report_description"
      label-cols-sm="3"
    >
      <b-form-input
        id="report_description"
        v-model="report.description"
        type="text"
        required
        autocomplete="report_description"
        placeholder="Description, or short name"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>

    <b-form-group
      label="Tags"
      label-for="tags-component-select"
      label-cols-sm="3"
    >
      <!-- Prop `add-on-change` is needed to enable adding tags vie the `change` event -->
      <b-form-tags
        id="tags-component-select"
        v-model="report.tags"
        size="lg"
        class="mb-2"
        add-on-change
        no-outer-focus
      >
        <template
          v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }"
        >
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                variant="info"
                >{{ tag }}</b-form-tag
              >
            </li>
          </ul>
          <b-form-select
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :disabled="disabled || usedTags.length === 0"
            :options="usedTags"
          >
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value="">Choose a tag...</option>
            </template>
          </b-form-select>
        </template>
      </b-form-tags>
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" v-on:click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
